import AxiosConfig from '@/config/axios-config'

export const PlanoAPI = {

  listarPlanosEmpresa () {
    return AxiosConfig.jalekoAPI().get('/admin/planos/empresa').then(response => response.data)
  },

  listarPorUsuarioDaEmpresa (idUsuario) {
    return AxiosConfig.jalekoAPI().get(`/admin/planos/${idUsuario}/empresa`).then(response => response.data)
  }

}

export default PlanoAPI
